import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API } from '@/config';

// Brand SVG icons — inline so they tree-shake well and don't require an
// extra icon library. Each icon stays at currentColor and respects size
// via the parent's className.
const Icons = {
  facebook: (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M22 12a10 10 0 1 0-11.56 9.88v-6.99H7.9V12h2.54V9.8c0-2.5 1.49-3.89 3.78-3.89 1.09 0 2.24.2 2.24.2v2.46h-1.26c-1.24 0-1.63.77-1.63 1.56V12h2.77l-.44 2.89h-2.33v6.99A10 10 0 0 0 22 12Z"/>
    </svg>
  ),
  instagram: (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M12 2.2c3.2 0 3.6 0 4.85.07 1.17.05 1.8.25 2.23.41.56.22.96.48 1.38.9.42.42.68.82.9 1.38.16.42.36 1.06.41 2.23.06 1.27.07 1.65.07 4.85s0 3.58-.07 4.85c-.05 1.17-.25 1.8-.41 2.23-.22.56-.48.96-.9 1.38a3.7 3.7 0 0 1-1.38.9c-.42.16-1.06.36-2.23.41-1.27.06-1.65.07-4.85.07s-3.58 0-4.85-.07c-1.17-.05-1.8-.25-2.23-.41a3.7 3.7 0 0 1-1.38-.9 3.7 3.7 0 0 1-.9-1.38c-.16-.42-.36-1.06-.41-2.23C2.2 15.58 2.2 15.2 2.2 12s0-3.58.07-4.85c.05-1.17.25-1.8.41-2.23.22-.56.48-.96.9-1.38.42-.42.82-.68 1.38-.9.42-.16 1.06-.36 2.23-.41C8.42 2.2 8.8 2.2 12 2.2Zm0 1.8c-3.15 0-3.51 0-4.74.07-1.07.05-1.65.23-2.04.38a2 2 0 0 0-.74.48 2 2 0 0 0-.48.74c-.15.39-.33.97-.38 2.04-.06 1.23-.07 1.59-.07 4.74s0 3.51.07 4.74c.05 1.07.23 1.65.38 2.04.13.34.29.58.48.74.16.19.4.35.74.48.39.15.97.33 2.04.38 1.23.07 1.59.07 4.74.07s3.51 0 4.74-.07c1.07-.05 1.65-.23 2.04-.38.34-.13.58-.29.74-.48.19-.16.35-.4.48-.74.15-.39.33-.97.38-2.04.06-1.23.07-1.59.07-4.74s0-3.51-.07-4.74c-.05-1.07-.23-1.65-.38-2.04a2 2 0 0 0-.48-.74 2 2 0 0 0-.74-.48c-.39-.15-.97-.33-2.04-.38C15.51 4 15.15 4 12 4Zm0 3.07a4.93 4.93 0 1 1 0 9.86 4.93 4.93 0 0 1 0-9.86Zm0 1.8a3.13 3.13 0 1 0 0 6.26 3.13 3.13 0 0 0 0-6.26Zm5.13-1.93a1.15 1.15 0 1 1 0 2.3 1.15 1.15 0 0 1 0-2.3Z"/>
    </svg>
  ),
  tiktok: (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.07A6.33 6.33 0 0 0 5.8 20.1a6.34 6.34 0 0 0 10.86-4.43V8.42a8.16 8.16 0 0 0 4.77 1.52V6.49a4.85 4.85 0 0 1-1.84-.07v.27Z"/>
    </svg>
  ),
  youtube: (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M23.5 6.2a3 3 0 0 0-2.12-2.12C19.42 3.6 12 3.6 12 3.6s-7.42 0-9.38.48A3 3 0 0 0 .5 6.2 31.4 31.4 0 0 0 0 12a31.4 31.4 0 0 0 .5 5.8 3 3 0 0 0 2.12 2.12c1.96.48 9.38.48 9.38.48s7.42 0 9.38-.48a3 3 0 0 0 2.12-2.12A31.4 31.4 0 0 0 24 12a31.4 31.4 0 0 0-.5-5.8ZM9.6 15.6V8.4l6.24 3.6L9.6 15.6Z"/>
    </svg>
  ),
  twitter: (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231 5.45-6.231Zm-1.161 17.52h1.833L7.084 4.126H5.117l11.966 15.644Z"/>
    </svg>
  ),
  linkedin: (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M20.45 20.45h-3.55v-5.57c0-1.33-.02-3.04-1.85-3.04-1.86 0-2.14 1.45-2.14 2.94v5.67H9.36V9h3.41v1.56h.05a3.74 3.74 0 0 1 3.36-1.84c3.59 0 4.25 2.36 4.25 5.44v6.29ZM5.34 7.43a2.06 2.06 0 1 1 0-4.11 2.06 2.06 0 0 1 0 4.11Zm1.78 13.02H3.56V9h3.56v11.45ZM22.22 0H1.77C.79 0 0 .77 0 1.72v20.56C0 23.23.79 24 1.77 24h20.45c.98 0 1.78-.77 1.78-1.72V1.72C24 .77 23.2 0 22.22 0Z"/>
    </svg>
  ),
  telegram: (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M22.05 2.27c-.36-.3-.93-.34-1.6-.07L1.7 9.55c-.96.38-1.1.93-1.1 1.23 0 .3.14.85 1.1 1.23l4.78 1.88 1.84 5.55c.23.7.81 1.16 1.54 1.16.46 0 .89-.19 1.22-.52l2.83-2.85 4.5 3.35c.51.38 1.06.57 1.59.57.99 0 1.78-.62 2.02-1.59l4.06-19.39c.13-.62-.09-1.2-.59-1.6Z"/>
    </svg>
  ),
  whatsapp: (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M17.5 14.4c-.3-.15-1.78-.88-2.06-.98-.28-.1-.48-.15-.68.15-.2.3-.78.98-.96 1.18-.18.2-.36.23-.66.08-.3-.15-1.27-.47-2.42-1.5-.9-.8-1.5-1.78-1.68-2.08-.18-.3-.02-.46.13-.61.13-.13.3-.34.45-.51.15-.18.2-.3.3-.5.1-.2.05-.38-.03-.53-.08-.15-.68-1.64-.93-2.24-.24-.59-.5-.5-.68-.51l-.58-.01c-.2 0-.53.08-.81.38-.28.3-1.06 1.04-1.06 2.54s1.09 2.95 1.24 3.15c.15.2 2.14 3.27 5.18 4.59.72.31 1.29.5 1.73.64.73.23 1.39.2 1.92.12.59-.09 1.78-.73 2.03-1.43.25-.7.25-1.3.18-1.43-.07-.13-.27-.21-.57-.36ZM12 1.6C6.26 1.6 1.6 6.26 1.6 12c0 1.9.5 3.71 1.43 5.33L1.6 22.4l5.21-1.4A10.36 10.36 0 0 0 12 22.4c5.74 0 10.4-4.66 10.4-10.4S17.74 1.6 12 1.6Z"/>
    </svg>
  ),
};

// Visual style per platform. Background gradients picked to evoke each brand
// without copying their logos pixel-for-pixel.
const STYLES = {
  facebook: 'bg-[#1877F2] hover:bg-[#166FE5]',
  instagram: 'bg-gradient-to-tr from-yellow-500 via-pink-500 to-purple-600 hover:brightness-110',
  tiktok: 'bg-black hover:bg-slate-800',
  youtube: 'bg-[#FF0000] hover:bg-[#E60000]',
  twitter: 'bg-black hover:bg-slate-800',
  linkedin: 'bg-[#0A66C2] hover:bg-[#0857A6]',
  telegram: 'bg-[#26A5E4] hover:bg-[#1F8DC4]',
  whatsapp: 'bg-[#25D366] hover:bg-[#1FB955]',
};

const LABELS = {
  facebook: 'Facebook',
  instagram: 'Instagram',
  tiktok: 'TikTok',
  youtube: 'YouTube',
  twitter: 'X (Twitter)',
  linkedin: 'LinkedIn',
  telegram: 'Telegram',
  whatsapp: 'WhatsApp',
};

// SocialIcons — pulls the admin-configured links from /site/settings/public
// and renders only the platforms that have a URL set. The component is
// self-fetching so it can be dropped anywhere (Footer, /support, /kontakt …)
// without prop wiring.
const SocialIcons = ({ size = 'md', className = '', heading = null }) => {
  const [links, setLinks] = useState(null);

  useEffect(() => {
    let alive = true;
    axios.get(`${API}/site/settings/public`)
      .then((r) => { if (alive) setLinks(r.data || {}); })
      .catch(() => { if (alive) setLinks({}); });
    return () => { alive = false; };
  }, []);

  if (!links) return null;

  const order = ['facebook', 'instagram', 'tiktok', 'youtube', 'twitter', 'linkedin', 'telegram', 'whatsapp'];
  const visible = order.filter((k) => (links[`${k}_url`] || '').trim());
  if (visible.length === 0) return null;

  const sizeClass = size === 'sm'
    ? 'w-8 h-8'
    : size === 'lg'
      ? 'w-12 h-12'
      : 'w-10 h-10';
  const iconSize = size === 'sm' ? 'w-4 h-4' : size === 'lg' ? 'w-6 h-6' : 'w-5 h-5';

  return (
    <div className={className} data-testid="social-icons">
      {heading && (
        <h3 className="text-sm font-semibold text-slate-300 mb-3">{heading}</h3>
      )}
      <div className="flex items-center gap-2 sm:gap-3 flex-wrap">
        {visible.map((key) => (
          <a
            key={key}
            href={links[`${key}_url`]}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={LABELS[key]}
            title={LABELS[key]}
            data-testid={`social-icon-${key}`}
            className={`${sizeClass} ${STYLES[key]} text-white rounded-full flex items-center justify-center transition-all hover:scale-110 shadow-md hover:shadow-lg`}
          >
            <span className={iconSize}>{Icons[key]}</span>
          </a>
        ))}
      </div>
    </div>
  );
};

export default SocialIcons;
